// extracted by mini-css-extract-plugin
export var allPostsLink = "SectionSummary-module--allPostsLink--dfcf2";
export var container = "SectionSummary-module--container--c556b";
export var featuredImage = "SectionSummary-module--featuredImage--c03e9";
export var icon = "SectionSummary-module--icon--8c778";
export var postBlock = "SectionSummary-module--postBlock--1bfdc";
export var postBlockTitle = "SectionSummary-module--postBlockTitle--45738";
export var postBlockTitleText = "SectionSummary-module--postBlockTitleText--ca5c3";
export var postBlock__image = "SectionSummary-module--postBlock__image--1f5a5";
export var postsList = "SectionSummary-module--postsList--248ab";
export var summaryCard = "SectionSummary-module--summaryCard--fe498";
export var summaryLinkBlock = "SectionSummary-module--summaryLinkBlock--e8071";